import React from 'react';
import './styles/ConfirmDialog.css';

const ConfirmDialog = ({ props, onConfirm, onCancel }) => {
  return (
    <div className="confirm-overlay">
      <div className="confirm-box">
        <p className="confirm-message">{props.message}</p>
        <div className="confirm-buttons">
          <button className="btn cancel" onClick={onCancel}>Cancel</button>
          <button className="btn confirm" onClick={onConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;